export default "__VITE_ASSET__aNSqyAGa__"